import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "semantic-ui-react";
import QRCode from "qrcode.react";
import InputCopy from "../../../components/CopyComponent/InputCopy";

const CryptoPayment = ({ paymentsDetail }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  return (
    <>
      <section>
        <span className="text-transaction-text dark:text-base-light-white">
          {i18n("chain")}
        </span>
        <Input disabled size="large" className="w-full">
          <input
            className="!text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark"
            type="text"
            value={paymentsDetail?.chain}
          />
        </Input>
      </section>
      <section>
        <span className="text-transaction-text dark:text-base-light-white">
          {i18n("address")}
        </span>
        <InputCopy copyLink={paymentsDetail?.address} />
      </section>
      <section>
        <span className="text-transaction-text dark:text-base-light-white">
          {i18n("qrcode")}
        </span>
        <div className="bg-hover-transaction-card dark:bg-base-light-dark rounded-[5px] py-[20px] flex items-center justify-center">
          <div className="bg-base-light-white dark:bg-base-light-dark p-[5px]">
            <QRCode value={paymentsDetail?.address} renderAs="canvas" />
          </div>
        </div>
      </section>
    </>
  );
};

export default CryptoPayment;
